import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { isLoggedIn } from '../utils/api'
import './ReviewPage.css'

const ReviewPage: React.FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoggedIn()) navigate('/login', { replace: true })
  }, [navigate])

  return (
    <div className="review-root">
      <header className="review-header"><strong>Pinjaman Kilat</strong></header>
      <main className="review-main">
        <div className="review-status-icon"><span>✓</span></div>
        <span className="review-eyebrow">PENGAJUAN DITERIMA</span>
        <h1>Data Anda Sedang Ditinjau</h1>
        <p className="review-lead">Tim kami sedang memverifikasi data pengajuan Anda. Hasil pemeriksaan akan disampaikan melalui SMS atau aplikasi.</p>

        <div className="review-card">
          <div className="review-timeline">
            <div className="review-item done"><i>✓</i><div><strong>Pengajuan dikirim</strong><span>Data berhasil kami terima</span></div></div>
            <div className="review-line active" />
            <div className="review-item active"><i>2</i><div><strong>Verifikasi data</strong><span>Sedang dalam proses pemeriksaan</span></div></div>
            <div className="review-line" />
            <div className="review-item"><i>3</i><div><strong>Keputusan</strong><span>Hasil akan segera diberitahukan</span></div></div>
          </div>
          <div className="review-estimate"><span>⏱️</span><div><small>Estimasi proses</small><strong>1–24 jam</strong></div></div>
        </div>

        <div className="review-note"><strong>Harap diperhatikan</strong><p>Pastikan nomor ponsel tetap aktif. Jangan memberikan kode OTP atau membayar biaya apa pun ke rekening pribadi.</p></div>
        <button className="review-home" onClick={() => navigate('/')}>Kembali ke Beranda</button>
      </main>
    </div>
  )
}

export default ReviewPage
